import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'activetime/company';

const companyActiveService = {
  getCompanyActive: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/companyActiveList`,
      data,
    });
  },

  createCompanyActive: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/companyActive`,
      data,
    });
  },

  deleteCompanyActive: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/companyActive/${encodeURIComponent(id)}`,
    });
  },

  updateCompanyActive: (id, data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/companyActive/${encodeURIComponent(id)}`,
      data,
    });
  },

  createCompanyActiveItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/companyActiveItem`,
      data,
    });
  },

  updateCompanyActiveItem: (id, data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/companyActiveItem/${encodeURIComponent(id)}`,
      data,
    });
  },

  deleteCompanyActiveItem: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/companyActiveItem/${encodeURIComponent(id)}`,
    });
  },

  getCompanyActiveItemsById: (id) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/companyActiveItem/${encodeURIComponent(id)}`,
    });
  },

  getCompanyDayOff: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/companyDayOffList`,
      data,
    });
  },

  createCompanyDayOff: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/companyDayOff`,
      data,
    });
  },

  deleteCompanyDayOff: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/companyDayOff/${encodeURIComponent(id)}`,
    });
  },

  updateCompanyDayOff: (id, data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/companyDayOff/${encodeURIComponent(id)}`,
      data,
    });
  },
};

export default companyActiveService;
